<script>
import { CdrButton, CdrText } from '@rei/cedar';
import ProductRecommendations from '../../../common/async-components/product-recommendations/AsyncProductRecommendations.vue';
import BrandTopCategories from './components/BrandTopCategories.vue';
import getRecs from '../../../utils/recommendations';
import analytics from '../../../common/mixins/analytics';

export default {
  name: 'BrandLandingDefault',
  components: {
    CdrButton,
    CdrText,
    BrandTopCategories,
    ProductRecommendations,
  },
  mixins: [analytics],
  props: {
    richRelevanceEnabled: { type: Boolean, default: true },
    brandName: { type: String, default: null },
    canonicalBrandName: { type: String, default: null },
    searchAllUrl: { type: String, default: null },
    brandCategories: { type: Array, default() { return null; } },
    totalProducts: { type: Number, default: null },
  },
  data() {
    return {
      recsPlacement: [],
      recsPlacementConfig: [{ placementType: 'brand_page.core_ol_rec_1' }],
    };
  },
  computed: {
    renderPage() {
      return this.totalProducts && this.brandCategories;
    },
    snapshotProducts() {
      return this.totalProducts === 1 ? 'product' : 'products';
    },
  },
  async mounted() {
    if (this.richRelevanceEnabled) {
      this.recsPlacement = await getRecs(this.recsPlacementConfig, 'brand', this.brandName);
    }
  },
};
</script>
<template>
  <div>
    <div
      v-if="renderPage"
      id="brand-landing"
      data-ui="brand-landing"
      class="brand-landing__container"
    >
      <cdr-text
        tag="h1"
        class="brand-landing__heading"
      >
        {{ brandName }}
      </cdr-text>
      <hr class="brand-landing__divider">
      <cdr-button
        :href="searchAllUrl"
        size="large"
        class="brand-landing__all-btn"
        tag="a"
      >
        Shop all {{ brandName }}
      </cdr-button>
      <cdr-text
        class="brand-landing__snapshot"
      >
        REI offers {{ totalProducts }} {{ brandName }} {{ snapshotProducts }}
      </cdr-text>
      <brand-top-categories
        :brand-categories="brandCategories"
        :brand-name="brandName"
        class="brand-landing__top-categories"
      />
      <section
        v-if="richRelevanceEnabled && !!recsPlacement[0]"
        class="brand-landing__recommendations"
      >
        <product-recommendations
          :placement="recsPlacement[0]"
          :metrics="metrics"
        />
      </section>
    </div>
    <div
      v-else
      class="brand-landing__container"
      data-ui="brand-landing-error"
    >
      <cdr-text
        tag="h1"
        class="brand-landing__heading"
      >
        {{ brandName }}
      </cdr-text>
      <hr class="brand-landing__divider">
      <cdr-text>
        We're having trouble retrieving information for {{ brandName }}.
        Please try again later or <a :href="searchAllUrl">search all {{ brandName }} products</a>.
      </cdr-text>
    </div>
  </div>
</template>
<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.brand-landing {
  &__container {
    @include cdr-container;
    text-align: center;
    margin-bottom: $cdr-space-two-x;
  }

  &__heading {
    @include cdr-text-heading-serif-strong-900;
    margin-top: $cdr-space-one-x;

    @include cdr-sm-mq-up {
      @include cdr-text-heading-serif-strong-1200;
    }
  }

  &__divider {
    width: 500px;
    border: 0;
    border-top: 1px solid #e5e5e5;
    margin: $cdr-space-one-x auto;

    @include cdr-xs-mq-only {
      width: 300px;
    }
  }

  &__snapshot {
    @include cdr-text-subheading-sans-400
  }

  &__recommendations,
  &__top-categories {
    margin-top: $cdr-space-three-x;
  }

  &__recommendations {
    overflow: hidden;
    text-align: left;
  }
  &__all-btn {
    margin: $cdr-space-one-x auto;

    @include cdr-xs-mq-only {
      margin: $cdr-space-two-x auto;
    }
  }
}
</style>
